import { AsyncPipe, DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { TimeconversionService } from '@fitness-force/api';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'time-formatted',
  templateUrl: './time-formatted.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, DatePipe],
})
export class TimeFormattedComponent implements OnInit {
  timeService = inject(TimeconversionService);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  keyName!: string;
  value!: number;
  format!: string;

  ngOnInit(): void {}

  getDate(date: any): Date {
    return this.timeService.ConvertUTCToLocalDateTime(date);
  }
}
